import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";

import Header from "./layouts/Header";
import Footer from "./layouts/Footer";

import Dashboard from "./main/dashboard/Index";
import Chat from "./main/application/chat";
import Inbox from "./main/application/inbox";
import BusinessListingForm from "./components/BusinessListingForm";
import CategoryWrapper from "./pages/CategoryWrapper";
import AllCategories from "./pages/AllCategories";
import Login from "./authentication/Login";
import OtpLogin from "./authentication/OtpLogin";
import Register from "./authentication/Register";
import ForgotPassword from "./authentication/forgot-password";
import LockScreen from "./authentication/lock-screen";

import Components from "./components/Index";
import Profile from "./pages/profile/Index";
import About from "./pages/about";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import AccountSettings from "./settings/AccountSettings";

import SassLogin from "./authentication/sass-login";
import SassRegister from "./authentication/sass-register";

// Jay
import Article1 from "./main/dashboard/Article1";
import Article2 from "./main/dashboard/Article2";
import Article3 from "./main/dashboard/Article3";
import Article4 from "./main/dashboard/Article4";
import Article5 from "./main/dashboard/Article5";
import Article6 from "./main/dashboard/Article6";
import Article7 from "./main/dashboard/Article7";

import Profilepage from "./main/dashboard/ProfilePage";
import Customerservice from "./main/dashboard/Customerservice";
import Privacypolicy from "./main/dashboard/Privacypolicy";
import Helpmodel from "./main/dashboard/HelpModal";

import HomeDiscoverySection from "./main/dashboard/HomeDiscoverySection";
import Agency from "./layouts/agency";
import ResetPassword from "./authentication/ResetPassword";


// Scroll to top when route changes
const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};

// Layout wrapper: hides header/footer on profilepage
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const hideLayout = location.pathname === "/profilepage";

  return (
    <>
      {!hideLayout && <Header />}
      {children}
      {!hideLayout && <Footer />}
    </>
  );
};

// ✅ PropTypes validation to fix ESLint warning
LayoutWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const AppContainer = () => {
  return (
    <Router>
      <ScrollToTop />
      <LayoutWrapper>
        <Switch>
          {/* ✅ HOME */}
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/index" component={Dashboard} />

          {/* MAIN PAGES */}
          <Route exact path="/about-us" component={About} />
          <Route exact path="/contact-us" component={Contact} />
          <Route exact path="/pricing" component={Pricing} />
          <Route exact path="/profile" component={Profile} />
          <Route path="/business-listing" component={BusinessListingForm} />
          <Route exact path="/all-categories" component={AllCategories} />
          <Route path="/category/:categoryName" component={CategoryWrapper} />
          <Route exact path="/chat" component={Chat} />
          <Route exact path="/inbox" component={Inbox} />
          <Route exact path="/components" component={Components} />
          <Route exact path="/settings" component={AccountSettings} />

          {/* AUTH PAGES */}
          <Route exact path="/login" component={Login} />
          <Route exact path="/OtpLogin" component={OtpLogin} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/lock-screen" component={LockScreen} />
          <Route exact path="/sass-login" component={SassLogin} />
          <Route exact path="/sass-register" component={SassRegister} />

          {/* ARTICLES */}
          <Route exact path="/article1" component={Article1} />  

          
          <Route exact path="/article2" component={Article2} />
          <Route exact path="/article3" component={Article3} />
          <Route exact path="/article4" component={Article4} />
          <Route exact path="/article5" component={Article5} />
          <Route exact path="/article6" component={Article6} />
          <Route exact path="/article7" component={Article7} />

          {/* OTHER ROUTES */}
          <Route exact path="/privacypolicy" component={Privacypolicy} />
          <Route exact path="/helpmodel" component={Helpmodel} />



          <Route exact path="/HomeDiscoverySection" component={HomeDiscoverySection} />
          <Route exact path="/agency" component={Agency} />



          {/* EXCLUDED HEADER/FOOTER */}
          <Route exact path="/profilepage" component={Profilepage} />
          <Route exact path="/Customerservice" component={Customerservice} />

          <Route path="/reset-password/:token" element={<ResetPassword />} />


        </Switch>
      </LayoutWrapper>
    </Router>
  );
};

export default AppContainer;
